import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircleRounded, InfoOutlined, PrintRounded, VerifiedUserRounded } from "@mui/icons-material";
import "./CareerFDCApplication.css";

const APPLICATION_URL = "/career/field-development-consultant/application";
const ACKNOWLEDGEMENT_URL = "/career/field-development-consultant/application/acceptance";

export default function FDCCareerSuccess() {
  const { state } = useLocation();
  const result = state?.submission;

  // A direct visit to this URL is not proof that an application was submitted.
  if (result?.status !== 201 || !/^FDC-[A-Za-z0-9-]{8,100}$/.test(result.applicationId || "")) {
    return (
      <main className="fdcCareerAppPage fdcCareerAppApplicationSuccess">
        <section className="fdcCareerAppOnboardSuccess">
          <div className="fdcCareerAppSuccessIcon"><InfoOutlined /></div>
          <h2>No submission confirmation available</h2>
          <p>This page is displayed after the application has been accepted by the server. Start or complete the online application to receive a confirmation reference.</p>
          <Link className="fdcSuccessLink" to={APPLICATION_URL}>Go to FDC application</Link>
        </section>
      </main>
    );
  }

  return (
    <main className="fdcCareerAppPage fdcCareerAppApplicationSuccess">
      <section className="fdcCareerAppOnboardSuccess">
        <div className="fdcCareerAppSuccessIcon"><CheckCircleRounded /></div>
        <div className="fdcCareerAppSuccessEyebrow"><VerifiedUserRounded /> APPLICATION RECEIVED</div>
        <h2>FDC career application submitted</h2>
        <p>
          Your Field Development Consultant application has been received for recruitment review.
          You are an applicant only; no staff account or employment appointment is activated until approval.
        </p>
        <div className="fdcCareerAppSuccessSummary">
          <div><small>APPLICANT</small><strong>{state?.applicantName || "FDC Applicant"}</strong></div>
          <div><small>APPLICATION REFERENCE</small><strong className="fdcSuccessReference">{result.applicationId}</strong></div>
          <div><small>WORKFLOW STATUS</small><strong>Submitted · Pending review</strong></div>
        </div>
        <div className="fdcCareerAppSuccessNote">
          <InfoOutlined />
          <span>Save your application reference for future correspondence. Submission does not guarantee selection or appointment.</span>
        </div>
        <div className="fdcSuccessActions">
          <Link className="fdcSuccessLink" to="/careers">Return to Careers</Link>
          <Link className="fdcSuccessLink fdcSuccessLink--secondary" to={ACKNOWLEDGEMENT_URL}><PrintRounded /> Print Acknowledgement Form</Link>
        </div>
      </section>
    </main>
  );
}
